import * as React from 'react';
type Props = {
  className: string;
  version: number;
};
import qlab1IconImage from 'assets/qlab-1-icon.png';
import qlab3IconImage from 'assets/qlab-3-icon.png';
import qlab4IconImage from 'assets/qlab-4-icon.png';
import qlab5IconImage from 'assets/qlab-5-icon.png';

// this is necessary because flow can't typecheck whatever require returns
// unless its argument is a string literal
const versionedSources = {
  '1': qlab1IconImage,
  '3': qlab3IconImage,
  '4': qlab4IconImage,
  '5': qlab5IconImage,
};
export default class QLabIcon extends React.Component<Props> {
  static defaultProps = {
    className: '',
    version: ENV.QLAB_CURRENT_MAJOR_VERSION,
  };
  render() {
    const { className, version } = this.props;
    return (
      <img
        className={className}
        src={versionedSources[version]}
        alt="QLab icon"
      />
    );
  }
}
export function iconSource(version: string) {
  return versionedSources[version];
}
